import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const createNewTransfer = (data) => apiActionCreator({
  'endpoint': '/transactions/parts/transfers/manuals',
  'authenticated': true,
  'types': [
    ActionTypes.CREATING_NEW_TRANSFER,
    [
      ActionTypes.CREATED_NEW_TRANSFER,
      MessageActions.addMessageBoxInfo('Transferencia ingresada satisfactoriamente'),
    ],
    [
      ActionTypes.CREATED_NEW_TRANSFER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  'data': data,
});

export const processStockTransfer = (data, fromOrder = true) => apiActionCreator({
  'endpoint': '/transactions/parts/transfers',
  'authenticated': true,
  'types': [
    ActionTypes.PROCESSING_STOCK_TRANSFER,
    [
      ActionTypes.PROCESSED_STOCK_TRANSFER,
      MessageActions.addMessageBoxInfo('Transferencia ingresada satisfactoriamente'),
    ],
    [
      ActionTypes.PROCESSED_STOCK_TRANSFER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  'data': {...data, 'fromOrder': fromOrder},
});

export const submitManualTransfer = (transferNumber) => apiActionCreator({
  'endpoint': `/transactions/parts/transfers/manuals/${transferNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.SUBMITTING_TRANSFER,
    [
      ActionTypes.SUBMITTED_TRANSFER,
      MessageActions.addMessageBoxInfo(`La transferencia ${transferNumber} se procesó satisfactoriamente`),
    ],
    [
      ActionTypes.SUBMITTED_TRANSFER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
});

export const rejectTransfer = (transferNumber) => apiActionCreator({
  'endpoint': `/transactions/parts/transfers/manuals/${transferNumber}`,
  'authenticated': true,
  'types': [
    ActionTypes.REJECTING_TRANSFER,
    ActionTypes.REJECTED_TRANSFER,
    [
      ActionTypes.REJECTED_TRANSFER_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'PUT',
});

export const addTransferItem = (transferNumber, index, itemData) => apiActionCreator({
  'endpoint': `/transactions/parts/transfers/manuals/${transferNumber}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.ADDING_TRANSFER_ITEM,
    {
      'type': ActionTypes.ADDED_TRANSFER_ITEM,
      'payload': index,
    },
    [
      ActionTypes.ADDED_TRANSFER_ITEM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'POST',
  'data': itemData,
});

export const removeTransferItem = (transferNumber, index, itemData) => apiActionCreator({
  'endpoint': `/transactions/parts/transfers/manuals/${transferNumber}/items`,
  'authenticated': true,
  'types': [
    ActionTypes.REMOVING_TRANSFER_ITEM,
    {
      'type': ActionTypes.REMOVED_TRANSFER_ITEM,
      'payload': index,
    },
    [
      ActionTypes.REMOVED_TRANSFER_ITEM_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'contentType': 'application/json',
  'microservice': 'part',
  'method': 'DELETE',
  'data': itemData,
});
